<template>
	<div class="menu-item-rows-container" @click="handleClick">
		<div v-for="item in items" :key="item.id">
			<menu-item-row :hasDiscount="hasDiscount" :item="item" :linked="true" />
		</div>
	</div>
</template>

<script>
	import MenuItemRow from '@/components/menu/common/MenuItemRow.vue';
	export default {
		components: {
			'menu-item-row': MenuItemRow,
		},
		props: {
			items: {
				type: Array,
			},
			afterClick: {
				type: Function,
				default: () => {},
			},
			hasDiscount: {
				type: Boolean,
				default: false
			},
		},
		methods: {
			handleClick() {
				this.afterClick();
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	.menu-item-rows-container {
		margin-top: 1rem;
	}
	.upsell-container {
		.menu-item-rows-container {
			margin-top: 0;
		}
	}
	.offers-container {
		.menu-item-rows-container {
			display: flex;
			flex-direction: column;
			justify-content: center;

			margin: auto;
			max-width: 22em;
		}
	}
	@include mobile {
		.offers-container {
			.menu-item-rows-container {
				max-width: 100%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/menu/common/MenuItemRows.vue